"use client"
import React from "react";
import CTA from "./valueprop/CTA";
import Link from "next/link";
import {useFeatureFlagVariantKey} from "posthog-js/react";

export default function Hero({
                                 title: controlTitle,
                                 subtitle: controlSubTitle,
                                 image,
                                 cta,
                                 subImage,
                                 siteConfig,
                                 variants,
                                 questions
                             }) {
    const scenario = useFeatureFlagVariantKey('promo-page-conversions')

    console.log(`Checking for variants for scenario ${scenario}`)

    function variant(attr) {
        return scenario && variants && variants[scenario] && variants[scenario][attr]
    }

    const {title, subtitle} = React.useMemo(() => {
        const title = variant('title') ? variant('title') : controlTitle
        const subtitle = variant('subtitle') ? variant('subtitle') : controlSubTitle
        return {title, subtitle}
    }, [scenario])

    return (
        <>
            <section className="hero-welcome-wrapper hero-1 page-heading">
                <div className="single-slide text-white">
                    <div className="container">
                        {
                            subImage?.url &&
                            <div className="row">
                                <div className="footer-logo d-block">
                                    <Link href="/wrapsody">
                                        <img src={subImage?.url} style={{width: 350}} alt="Wrapsody by POLN"/>
                                    </Link>
                                </div>
                            </div>
                        }
                        <div className="row">
                            <div className="col-xl-8 col-12 col-lg-10 offset-lg-1 offset-xl-0">
                                <div className="hero-contents">
                                    <h1>{title}</h1>
                                    <h5>
                                        {subtitle}
                                    </h5>
                                    {cta &&
                                        <div className="hero-banner-cta d-flex flex-row pb-4">
                                            {
                                                (cta?.length > 1) ?
                                                    cta?.map((itm, index) => <CTA cta={itm} questions={questions}
                                                                                  siteConfig={siteConfig}/>)
                                                    :
                                                    <CTA cta={cta} questions={questions} siteConfig={siteConfig}/>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                            {
                                image?.url &&
                                <div
                                    className="col-xl-4 col-xs-12 col-12 text-xl-end col-lg-10 offset-lg-1 offset-xl-0">
                                    <div className="hero-mobile mt-xl-0">
                                        <p className="text-center"><img src={image?.url} alt={image?.alt}/></p>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}


